import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../../../common/ProgressBar/containers/ProgressBar';
import './DetailsLayout.css';
import TrustedInsurers from './TrustedInsurers';
import QuizBar from './QuizBar';
import QuizQuestion from './Quiz/QuizQuestion';
import QuizNav from '../../../common/QuizNav/QuizNav';
import Breadcrumb from '../../../common/Breadcrumb/Breadcrumb';

const DetailsLayout = props => {
  const isFirstQuestion =  props.currentQuestionI == 0;
  const showPrevious = !isFirstQuestion && !props.hidePreviousQuestion;
  const isContactInfo = props.currentQuestion.type === "QuizContactInformation";
  const goingBackToOptions = props.currentQuestion.type === "QuizTwoOptionsSelect" && props.enableContinueForTwoOptions;
  const showContinue = (!isContactInfo && props.currentQuestion.type !== "QuizTwoOptionsSelect") || goingBackToOptions || (props.currentQuestion.type == "QuizTwoOptionsSelect" && !isFirstQuestion);
  const isChatGptDerivedUser = props.chatGptDerived === 'true';
  const normalizedCoverage = Number(String(props.coverage || '').replace(/[^\d]/g, ''));
  const hideHeaderProgressBar = isChatGptDerivedUser && normalizedCoverage > 50000;

  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://choicemutual.com';
  const breadcrumbItems = [
    { label: 'Home', url: baseUrl },
    { label: 'Life Insurance Tools', url: `${baseUrl}/life-insurance-tools/` },
    { label: 'Final Expense Quotes Calculator' }
  ];

  return (
    <section className="details">
      <Breadcrumb items={breadcrumbItems} />

      {!hideHeaderProgressBar && (
        <div className="progressBarWrapper d-md-none d-flex align-items-center content generalInformation">
          <ProgressBar />
        </div>
      )}

      <div className='blobWrapper'>
        <div className="mx-0 c-quoting-blob py-6 content">
          <h1 className='title text-center'>Life & Burial Insurance Quotes Calculator</h1>
          <QuizBar {...props}/>
          {
            props.questions.map((question, i)=> 
              <QuizQuestion 
                key={`quizQuestionKey${i}`}
                {...props}
                question={question}
                questionI={i}
              />
           )
          }
          <QuizNav 
            showPrevious={showPrevious} 
            showContinue={showContinue}
            previousQuestion={props.previousQuestion}
            currentValueFullfilled={props.currentValueFullfilled}
            currentQuestionI={props.currentQuestionI}
            nextQuestion={props.nextQuestion}
          />
          <TrustedInsurers {...props} />
        </div>
      </div>


    </section>
  );
};

DetailsLayout.propTypes = {
  handleOption: PropTypes.func.isRequired,
  toggleGenderSelect: PropTypes.func.isRequired,
  toggleSmokeSelect: PropTypes.func.isRequired,
  handleDetailsSubmit: PropTypes.func.isRequired
};

export default DetailsLayout;
